import CompanyTabs from "#src/components/companyTabs";
import {useParams} from "react-router-dom";
import {Sagis} from "./sagis";
import {Hf} from "#src/pages/company/integrations/hf";
import {Urbanistic} from "#src/pages/company/integrations/urbanistic";
import {Tetraeder} from "#src/pages/company/integrations/tetraeder";
import {Inspire} from "#src/pages/company/integrations/inspire";

export const Intergrations = () => {

    const {id} = useParams();

    return (
        <div className="mx-auto max-w-7xl w-full bg-gray-100 px-4">
            <h2 className="text-xl my-8 flex  font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                Account
            </h2>
            <CompanyTabs page={"Integrationen"}/>
            <div className=" mb-12 w-full  gap-x-8">

                { id === "nti-qgis-plugin" && (<Sagis/>) }
                { id === "hf" && (<Hf/>) }
                { id === "urbanistic" && (<Urbanistic/>) }
                { id === "tetraeder" && (<Tetraeder/>) }
                { id === "inspire" && (<Inspire/>) }

            </div>
        </div>

  )
}
